module.exports = __webpack_public_path__ + "static/media/add-image.2d50bd5a.svg";